<p-chart [type]="type" [data]="data" [options]="options"></p-chart>
<ng-template #noData>
    <div class="no-chart-data">
        <mat-icon svgIcon="chart_icon"></mat-icon>
    </div>
    <p>{{'general.texts.noChartData' | translate}}</p>
</ng-template>
